import desc_img from "../../images/login/desc-img.png";
import desc_img2 from "../../images/login/signup-2.png";
import desc_img3 from "../../images/login/signup-3.png";

class LoginAPI {
    static fetchLoginBenefits = () => {
        return [
            {
              img: desc_img,
              title: 'Work From Anywhere Anytime',
              subTitle: 'Find great works just from home and work from home just from home and work from home'
            },
            {
              img: desc_img2,
              title: 'Work From Anywhere Anytime',
              subTitle: 'Find great works just from home and work from home just from home and work from home'
            },
            {
              img: desc_img3,
              title: 'Work From Anywhere Anytime',
              subTitle: 'Find great works just from home and work from home just from home and work from home'
            }
          ]
    }
}
export default LoginAPI;